import { render, staticRenderFns } from "./AuthorizationRow.vue?vue&type=template&id=844b886a&scoped=true&"
import script from "./AuthorizationRow.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRow.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationRow.vue?vue&type=style&index=0&id=844b886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844b886a",
  null
  
)

export default component.exports